"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditPads = void 0;
const filter_bar_1 = require("client/components/filter-bar");
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const table_row_1 = require("client/components/material/table/table-row");
const text_field_1 = require("client/components/material/text-field");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/pads/store");
const store_2 = require("client/modules/sites/modules/sites-detail/store");
const store_3 = require("client/modules/users/store");
const Table_1 = require("material-ui/Table");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const react_1 = require("react");
const React = require("react");
const ReactTooltip = require("react-tooltip");
const pad_1 = require("shared/pad");
const throttle_debounce_1 = require("throttle-debounce");
require("./edit-pads.less");
const columns = [
    {
        center: false,
        id: "pad.name",
        numeric: false,
        label: "Name"
    },
    {
        center: false,
        id: "pad.online",
        numeric: false,
        label: "Status"
    },
    {
        center: false,
        id: "pad.provisioned",
        numeric: false,
        label: ""
    }
];
let EditPads = class EditPads extends react_1.Component {
    constructor() {
        super(...arguments);
        this.editPadId = -1;
        this.filterText = "";
        this.isCollapse = true;
        this.order = "ASC";
        this.orderBy = "pad.name";
        this.autoFocusForm = true;
        this.loadPads = throttle_debounce_1.debounce(200, () => {
            // console.info("loadPads activated");
            if (store_2.sitesDetailStore.site.value) {
                // console.info("site is", sitesDetailStore.site.value.id);
                store_2.sitesDetailStore.loadPads({
                    id: store_2.sitesDetailStore.site.value.id,
                    order: this.order,
                    search: this.filterText,
                    sort: this.orderBy
                });
            }
        });
        this.onCallback = (value) => {
            this.autoFocusForm = false;
            this.filterText = value;
            this.loadPads();
        };
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadPads();
        };
        this.renderTable = () => (React.createElement("div", { className: "pads__list" }, store_2.sitesDetailStore.pads.value && (React.createElement(ui_1.UiForm, { loading: store_2.sitesDetailStore.pads.loading, isChanged: this.isChanged, status: store_2.sitesDetailStore.pads.status, saved: "Saved", onSubmit: this.handleSubmit, error: store_2.sitesDetailStore.pads.error },
            React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: store_2.sitesDetailStore.pads.value, renderRow: this.renderTableRow, wideHeader: false, resizableheader: true, customClass: "custom-material-list__site-pads-list" })))));
        this.renderTableRow = (row, index) => {
            const statusClass = row.online ? pad_1.PadStatus.Online : pad_1.PadStatus.Offline;
            return [
                React.createElement(table_row_1.MaterialTableRow, { key: index, onClick: () => this.handleClickRow(row, index) },
                    React.createElement(Table_1.TableCell, null, row.name),
                    React.createElement(Table_1.TableCell, null,
                        React.createElement("div", { className: "edit-pads__row" },
                            React.createElement("div", { className: `edit-pads__status edit-pads__status--${statusClass}` }),
                            " ",
                            React.createElement("div", { className: "edit-pads__status-text" }, row.online ? pad_1.PadStatus.Unlocked : pad_1.PadStatus.Locked))),
                    React.createElement(Table_1.TableCell, null,
                        React.createElement("a", { href: "/pad", target: "_blank", onClick: this.handleConnectPad(row) },
                            React.createElement(button_1.MaterialButton, { flat: true, primary: true, className: "pad-remove-btn" }, "Connect")))),
                this.renderTableRowEditMode(row, index)
            ].filter(o => o !== null);
        };
        this.handlePadRemove = (pad) => async (event) => {
            event.preventDefault();
            event.stopPropagation();
            store_1.padsStore.resetPadCache();
            await store_1.padsStore.removePad(pad);
        };
        this.handleConnectPad = (pad) => async (event) => {
            // event.preventDefault();
            event.stopPropagation();
            localStorage.setItem("name", pad.name);
            localStorage.setItem("siteId", String(pad.siteId));
            localStorage.setItem("socketId", pad.socketId);
        };
        this.renderTableRowEditMode = (child, index) => this.editPadId === child.id && !this.isCollapse ? (React.createElement(table_row_1.MaterialTableRow, { key: -1 },
            React.createElement(Table_1.TableCell, { colSpan: 3 },
                React.createElement("div", { className: "edit-padinfo", key: -1 },
                    React.createElement("div", { className: "list-component__row" }, this.renderPadInfo(child)))))) : null;
        this.renderPadInfo = (pad) => (React.createElement("div", { className: "pad-edit-container" },
            React.createElement("div", { className: "main" },
                React.createElement("div", { className: "pad-name" },
                    React.createElement("h3", null, pad.name),
                    React.createElement("h4", null, pad.online ? pad_1.PadStatus.Unlocked : pad_1.PadStatus.Locked)),
                React.createElement("div", { className: "pad-info" },
                    React.createElement("div", { className: "row" },
                        React.createElement(text_field_1.MaterialTextField, { autoFocus: this.autoFocusForm, label: "Name", onChange: this.handleChangeName, type: "text", value: this.pad ? this.pad.name : "" })))),
            React.createElement("div", { className: "row pad-info__buttons" },
                React.createElement(button_1.MaterialButton, { flat: true, className: "pad-remove-btn", onClick: this.handlePadRemove(pad) }, "Delete"),
                React.createElement("div", null,
                    React.createElement(button_1.MaterialButton, { className: "btnCancelRow", onClick: this.handleCancelRow }, "Cancel"),
                    React.createElement(button_1.MaterialButton, { onClick: this.handleSaveRow, className: `button-status-${this.isChanged() ? ui_1.FormStatus.Dirty : store_2.sitesDetailStore.pads.status}`, primary: true }, !this.isChanged() &&
                        store_2.sitesDetailStore.pads.status === ui_1.FormStatus.Saved
                        ? "Saved"
                        : "Save")))));
        this.isChanged = () => {
            const pad = store_2.sitesDetailStore.pads.value &&
                store_2.sitesDetailStore.pads.value.find(p => Boolean(this.pad && p.id === this.pad.id));
            return Boolean(this.pad && pad && this.pad.name !== pad.name);
        };
        this.handleClickProvision = async (row) => {
            console.info("row is", row);
            if (store_2.sitesDetailStore.site.value) {
                if (row.provisioned) {
                    await store_2.sitesDetailStore.unprovisionPad(row);
                }
                else {
                    await store_2.sitesDetailStore.provisionPad(row, store_2.sitesDetailStore.site.value);
                }
                // this.loadPads();
            }
        };
        this.handleClickRow = (row, index) => {
            if (this.editPadId === row.id) {
                this.isCollapse = !this.isCollapse;
                this.autoFocusForm = true;
            }
            else {
                this.isCollapse = false;
            }
            this.editPadId = row.id;
            this.pad = row;
        };
        this.handleCancelRow = () => {
            this.editPadId = -1;
            this.pad = undefined;
        };
        this.handleChangeName = (event, value) => {
            this.pad = ramda_1.merge(this.pad, {
                name: value
            });
        };
        this.handleSaveRow = () => {
            this.handleSubmit();
            this.editPadId = -1;
        };
        this.handleSubmit = async () => {
            if (this.pad) {
                await store_2.sitesDetailStore.savePad(this.pad);
                this.loadPads();
            }
        };
    }
    // @TKay added
    async componentWillMount() {
        store_2.sitesDetailStore.readSite(store_3.usersStore.user.value.siteId);
    }
    componentDidMount() {
        store_3.usersStore.loadUser();
        window.clearInterval(this.loadPadsInterval);
        this.loadPadsInterval = window.setInterval(() => {
            this.loadPads();
        }, 2500);
    }
    componentWillUnmount() {
        window.clearInterval(this.loadPadsInterval);
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    render() {
        return (React.createElement("div", { className: "edit-pads" },
            store_3.usersStore.permissions.ReadPads ? (React.createElement(React.Fragment, null,
                !this.props.noSearchFilter && this.renderFilter(),
                this.renderTable())) : (store_3.usersStore.showLock()),
            React.createElement(ReactTooltip, { effect: "solid", place: "left" })));
    }
    renderFilter() {
        return (React.createElement("div", { className: "pads__filter" },
            React.createElement(filter_bar_1.FilterBar, { callBack: this.onCallback, filterText: this.filterText })));
    }
};
__decorate([
    mobx_1.observable
], EditPads.prototype, "editPadId", void 0);
__decorate([
    mobx_1.observable
], EditPads.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], EditPads.prototype, "isCollapse", void 0);
__decorate([
    mobx_1.observable
], EditPads.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], EditPads.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], EditPads.prototype, "pad", void 0);
__decorate([
    mobx_1.observable
], EditPads.prototype, "autoFocusForm", void 0);
EditPads = __decorate([
    mobx_react_1.observer
], EditPads);
exports.EditPads = EditPads;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/components/edit-pads/edit-pads.tsx
// module id = 3358
// module chunks = 0